"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("../axios.js"));

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// This service is used to store files via a signed URL in an AWS bucket
// It interfaces with the Grind Team's 'object-storage-service'
// eslint-disable-next-line max-len
// swagger docs can be found here: https://api-devci.poc.learning.amplify.com/openapi-ui/?urls.primaryName=endpoint-ui%3A%20object%20storage%20%40%20devci
// Postman docs can be found in the JIRA ticket: https://amplify-education.atlassian.net/browse/WEEBUG-2956
var objectService = new _GatewayService["default"]('object'); // filetype must be a valid MIME type. For unknown or binary data use 'application/octet-stream'

var sendObject = function sendObject(userKey, activityKey, filename, filetype, object) {
  return getUploadURL(userKey, activityKey, filename, filetype).then(function (getUploadResponse) {
    return uploadToSignedURL(getUploadResponse.url, object, filetype).then(function () {
      return markUploaded(getUploadResponse.id);
    });
  });
}; // the file is indexed by an internal ID, but we can use the filename to get that id


var fetchObjectByFileName = function fetchObjectByFileName(userKey, activityKey, fileName, filetype) {
  return getFileID(userKey, activityKey, fileName).then(function (fileId) {
    if (fileId) {
      return fetchObject(fileId, filetype);
    } else {
      console.log("Trying to fetch object with name \"".concat(fileName, "\" which doesn't exist in storage anymore"));
      return null;
    }
  });
};

var getUploadURL = function getUploadURL(userKey, activityKey, filename, filetype) {
  return objectService.post('upload', {
    'userBusinessKey': userKey,
    'activityBusinessKey': activityKey,
    'fileName': filename,
    'contentType': filetype
  }).then(function (response) {
    return response;
  });
}; // we have to use axios directly (no gateway service) as we are hitting the returned URL directly


var uploadToSignedURL = function uploadToSignedURL(url, object, filetype) {
  // the URL is signed, if we send the Bearer token in the header the request will fail for
  // 'multiple authorization' so tell axios not to add it automatically
  return _axios["default"].put(url, object, {
    stripAuthorization: 'true',
    headers: {
      'Content-Type': filetype
    }
  }).then(function (res) {
    return res.data;
  });
}; // once the upload is successful, tell the endpoint to mark it READY


var markUploaded = function markUploaded(fileId) {
  return objectService.get("".concat(fileId, "/uploaded"));
}; // The endpoint uses IDs that it generates, but if we only know the filename, we can get the ID from 'list/'


var getFileID = function getFileID(userKey, activityKey, fileName) {
  return objectService.get("list/".concat(userKey, "/").concat(activityKey)).then(function (response) {
    var fileInfo = _lodash["default"].find(response, function (entry) {
      return entry.fileName === fileName;
    });

    return fileInfo ? fileInfo.id : undefined;
  });
};

var fetchObject = function fetchObject(fileId, filetype) {
  var config = {
    headers: {
      'Content-Type': filetype
    },
    responseType: 'blob'
  };
  return objectService.get("".concat(fileId, "/download"), config).then(function (object) {
    return object;
  });
};

var deleteObjectByFileName = function deleteObjectByFileName(userKey, activityKey, fileName) {
  getFileID(userKey, activityKey, fileName).then(function (fileId) {
    if (fileId) {
      return deleteObject(fileId);
    } else {
      console.log("Trying to delete object with name \"".concat(fileName, "\" which doesn't exist in storage anymore"));
      return null;
    }
  });
};

var deleteObject = function deleteObject(fileId) {
  objectService["delete"]("".concat(fileId)).then(function (response) {
    return response;
  });
};

var _default = {
  sendObject: sendObject,
  fetchObjectByFileName: fetchObjectByFileName,
  fetchObject: fetchObject,
  deleteObject: deleteObject,
  deleteObjectByFileName: deleteObjectByFileName
};
exports["default"] = _default;